import ScheduleSystemScreen from "./SchedyleSystemScreen";


export default ScheduleSystemScreen;